export default "__VITE_ASSET__Kf46maLR__"